<template>
  <div v-if="isAdmin" class="playground panel-admin-body">
      <download-comments :entry-survey-code="this.surveyCode" :client-object="this.clientObject"></download-comments>
  </div>

  <div v-else class="panel-admin-body no-permission-list">
    You do not have permission to view this page
  </div>
</template>

<script>
import ViewMixins from "../mixins/ViewMixins.vue";
import AdminMixins from "../mixins/AdminMixins.vue";
import DataTableMixins from "../mixins/DataTableMixins.vue";
import ContentMixins from "../mixins/ContentMixins.vue";
import DownloadComments from "../components/chart/DownloadComments.vue";
const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
  name: "Playground",
  components: {DownloadComments},
  mixins: [AdminMixins, ViewMixins, DataTableMixins, ContentMixins],
  data() {
    return {
      
    };
  },
  methods: {
  }
};
</script>

<style scoped>
</style>
